import PipelineCancelled from './Charts/pipelineCancelled';
import PipelineFunded from './Charts/pipelineFunded';
import PipelineConversion from './Charts/pipelineConversions';
import Leaderboards from './Charts/leaderboards';
import Birthdays from './Charts/birthdays';


const chartMap = {
  'pipe-cancelled': PipelineCancelled,
  'pipe-fund-summary': PipelineFunded,
  'pipe-conversion': PipelineConversion, 
  'partner-leaderboard': Leaderboards,
  'borrower-bday': Birthdays,
  // ...add more mappings as needed
};

export default function ReportChart({ reportType, data, filters }) {
  const ChartComponent = chartMap[reportType];

  if (!ChartComponent) {
    return <div className="text-muted">No chart available for this report.</div>;
  }

  return <ChartComponent data={data} filters={filters} />;
}